let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e8krP")).then(() => parcelRequire('6JNBC'));